import React from 'react';
import { Link } from 'react-router-dom';

function PrayerLessonsPage() {
  return (
    <div className="h-full bg-blue-50 flex flex-col items-center justify-center p-6 text-center overflow-y-auto">
      <h1 className="text-4xl font-extrabold mb-4 text-blue-700 drop-shadow-md">
        🌙 Learn How to Pray (Salah)
      </h1>
      <p className="mb-8 text-lg text-gray-600 max-w-xl">
        Follow this step-by-step guide to learn the correct movements and words for Salah — in a way that's easy and fun!
      </p>

      <div className="flex flex-col sm:flex-row gap-6 w-full max-w-md items-center justify-center">
        {/* Male Prayer Steps */}
        <Link
          to="/prayer-steps"
          className="w-full sm:w-auto px-8 py-4 bg-yellow-400 hover:bg-yellow-500 text-white text-lg font-bold rounded-2xl shadow-lg transition-all duration-300 flex items-center justify-center gap-2"
        >
          🧍 Start Salah (Male)
        </Link>

        {/* Female Prayer Steps */}
        <Link
          to="/female-prayer-steps"
          className="w-full sm:w-auto px-8 py-4 bg-pink-400 hover:bg-pink-500 text-white text-lg font-bold rounded-2xl shadow-lg transition-all duration-300 flex items-center justify-center gap-2"
        >
          🧕 Start Salah (Female)
        </Link>
      </div>
    </div>
  );
}

export default PrayerLessonsPage;
